const languages = [
  "Java",
  "C",
  "Python",
  "JavaScript",
  "SQL",
  "HTML",
  "CSS",
];

export default languages;